import { db } from '../../utils/firebase';

// og
// export const getAllPublications = async () => {
//   const querySnapshot = await db.collection("publications").get();
//   const promises = [];
//   const content = [];
//   querySnapshot.forEach(doc => {
//     // doc.data() is never undefined for query doc snapshots
//     const { year } = doc.data();
//     // get children for each section
//     promises.push(
//       db
//         .collection("publications")
//         .doc(year)
//         .collection("children")
//         .orderBy("order", "asc")
//         .get()
//     );
//     content.push({ year, children: [] });
//   });


// new
export const getAllPublications = async () => {
  const querySnapshot = await db.collection("publications").orderBy("year", "desc").get();
  const promises = [];
  const content = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    const { year } = doc.data();
    // get children for each section
    promises.push(
      db
        .collection("publications")
        .doc(year)
        .collection("children")
        .orderBy("order", "asc")
        .get()
    );
    content.push({ year, children: [] });
  });


  // og
  // const snapshots = await Promise.all(promises);
  // var i = 0;
  // snapshots.forEach(querySnapshot1 => {
  //   const childrens = [];
  //   querySnapshot1.forEach(doc => {
  //     // get single children
  //     const { title, papers } = doc.data();
  //     childrens.push({ title, papers });
  //   });
  //   //sort title in descending order so that journals come first and conference papers come second
  //   childrens.sort(function(a, b){
  //     let x = a.title.toLowerCase();
  //     let y = b.title.toLowerCase();
  //     if (x < y) {return 1;}
  //     if (x > y) {return -1;}
  //     return 0;
  //   });
  //   content[i].children = childrens;
  //   ++i;
  // });

  // new
  const snapshots = await Promise.all(promises);
  var i = 0;
  snapshots.forEach(querySnapshot1 => {
    const childrens = [];
    querySnapshot1.forEach(doc => {
      // get single children
      const { title, papers, order } = doc.data();
      childrens.push({ title, papers, order });
    });
    //sort title in descending order so that journals come first and conference papers come second
    childrens.sort((a, b) => a.order - b.order);
    content[i].children = childrens;
    ++i;
  });

  // content.sort((a, b) => b.year - a.year);
  content.sort(function(a,b){
    if(a.year == "Interaction Lab PhD Dissertations") return 1;
    else if(b.year == "Interaction Lab PhD Dissertations") return -1;
    else return b.year - a.year;
  });

  // For each year reverse the order of the publications for years equal or after 2022
  content.forEach(yearOfPubs => {
    if(yearOfPubs.year != "Interaction Lab PhD Dissertations" || parseInt(yearOfPubs.year) >= 2023){
      yearOfPubs.children.forEach(paperCollection => {
        paperCollection.papers = paperCollection.papers.reverse()
      })
    }
  })
  return content;

}
